import { render, staticRenderFns } from "./MetricsAndAlertsOverlay.vue?vue&type=template&id=633376c9"
import script from "./MetricsAndAlertsOverlay.vue?vue&type=script&lang=js"
export * from "./MetricsAndAlertsOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports